(function () {
  'use strict';
  function qs(r, s) {
    return (r || document).querySelector(s);
  }
  function qsa(r, s) {
    return [].slice.call((r || document).querySelectorAll(s));
  }
  function notifySuccess() {
    if (typeof theme !== 'undefined' && theme.Notify) theme.Notify.open('success', false, true);
  }
  function notifyError(m) {
    if (typeof theme !== 'undefined' && theme.Notify) theme.Notify.open('error', m || 'Błąd', true);
    else alert(m || 'Błąd');
  }
  function updateCartIndicator() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var ind = qs(document, '.site-header__cart-indicator');
        if (ind) {
          if (cart.item_count > 0) ind.classList.remove('hide');
          else ind.classList.add('hide');
        }
      })
      .catch(function () {});
  }

  function parseProtocolSlots() {
    var el = qs(document, 'script[type="application/json"][data-luxio-protocol-slots]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function cartHasVariantId(cart, vid) {
    var s = String(vid);
    return (cart.items || []).some(function (item) {
      return String(item.variant_id) === s;
    });
  }

  function parseKitMsgs() {
    var el = qs(document, 'script[type="application/json"][data-luxio-kit-msgs]');
    if (!el) return { one: '', many: '', top_hint: '', done: '' };
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function formatLuxioMoney(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        var fmt = (typeof theme !== 'undefined' && theme && theme.moneyFormat) || '{{amount}}';
        return Shopify.formatMoney(n, fmt);
      } catch (e) {}
    }
    return (n / 100).toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' });
  }

  function setCardPriceFromOption(priceEl, opt) {
    if (!priceEl || !opt) return;
    var cents = Number(opt.getAttribute('data-cents')) || 0;
    var compare = Number(opt.getAttribute('data-compare-cents')) || 0;
    if (compare > cents) {
      priceEl.innerHTML =
        '<span class="luxio-lp-card__compare">' +
        formatLuxioMoney(compare) +
        '</span><span class="luxio-lp-card__current">' +
        formatLuxioMoney(cents) +
        '</span>';
    } else {
      priceEl.textContent = formatLuxioMoney(cents);
    }
  }

  function clampQty(input) {
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (!isFinite(v) || v < 1) v = 1;
    if (v > 999) v = 999;
    input.value = String(v);
  }

  function initCardVariantQty(root) {
    qsa(root, '[data-luxio-variant-picker]').forEach(function (sel) {
      if (sel.dataset.luxioVariantBound) return;
      sel.dataset.luxioVariantBound = '1';
      var card = sel.closest('[data-luxio-product-card]');
      var imgEl = card ? qs(card, '.luxio-lp-card__img') : null;
      if (imgEl && !imgEl.dataset.luxioOrigSrc) {
        imgEl.dataset.luxioOrigSrc = imgEl.src || '';
        imgEl.dataset.luxioOrigSrcset = imgEl.getAttribute('srcset') || '';
      }
      var priceEl = card ? qs(card, '[data-luxio-card-price]') : null;
      var btn = card ? qs(card, '[data-luxio-add-btn]') : null;
      var addLabel = btn ? btn.getAttribute('data-luxio-add-label') || btn.textContent.trim() : '';
      var soldLabel = btn ? btn.getAttribute('data-luxio-sold-label') || 'Wyprzedane' : 'Wyprzedane';

      function sync() {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        setCardPriceFromOption(priceEl, opt);
        if (btn) {
          btn.disabled = opt.disabled;
          btn.textContent = opt.disabled ? soldLabel : addLabel;
        }
        if (card) card.setAttribute('data-luxio-variant-id', opt.value);
        if (imgEl) {
          var uMain = opt.getAttribute('data-img');
          if (uMain) {
            var u1200 = opt.getAttribute('data-img-1200');
            var u1800 = opt.getAttribute('data-img-1800');
            var u2400 = opt.getAttribute('data-img-2400');
            var u3840 = opt.getAttribute('data-img-3840');
            imgEl.src = uMain;
            if (u1200 && u1800 && u2400 && u3840) {
              imgEl.srcset =
                u1200 +
                ' 1200w, ' +
                u1800 +
                ' 1800w, ' +
                u2400 +
                ' 2400w, ' +
                uMain +
                ' 3072w, ' +
                u3840 +
                ' 3840w';
            } else imgEl.removeAttribute('srcset');
          } else if (imgEl.dataset.luxioOrigSrc) {
            imgEl.src = imgEl.dataset.luxioOrigSrc;
            if (imgEl.dataset.luxioOrigSrcset) imgEl.setAttribute('srcset', imgEl.dataset.luxioOrigSrcset);
            else imgEl.removeAttribute('srcset');
          }
        }
      }
      sel.addEventListener('change', sync);
      sync();
    });

    qsa(root, '.luxio-lp-card__qty-wrap').forEach(function (wrap) {
      if (wrap.dataset.luxioQtyBound) return;
      wrap.dataset.luxioQtyBound = '1';
      var input = qs(wrap, '.luxio-lp-card__qty');
      var dec = qs(wrap, '[data-luxio-qty-dec]');
      var inc = qs(wrap, '[data-luxio-qty-inc]');
      if (!input) return;
      function bump(delta) {
        var v = parseInt(input.value, 10) || 1;
        input.value = String(Math.min(999, Math.max(1, v + delta)));
      }
      if (dec) dec.addEventListener('click', function () { bump(-1); });
      if (inc) inc.addEventListener('click', function () { bump(1); });
      input.addEventListener('blur', function () { clampQty(input); });
      input.addEventListener('change', function () { clampQty(input); });
    });
  }

  function initAjaxAdd(root) {
    qsa(root, '.luxio-lp-ajax-form').forEach(function (form) {
      if (form.dataset.luxioAjaxBound) return;
      form.dataset.luxioAjaxBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var prev = btn ? btn.textContent : '';
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(function (r) {
            return r.json().then(function (j) {
              if (!r.ok) throw new Error((j && j.description) || r.statusText);
              return j;
            });
          })
          .then(function () {
            notifySuccess();
            updateCartIndicator();
            document.dispatchEvent(new CustomEvent('luxio:cart-changed', { detail: { added: true } }));
            if (btn) {
              btn.disabled = true;
              btn.textContent = 'Dodano';
              btn.classList.add('luxio-lp-card__btn--done');
              setTimeout(function () {
                btn.disabled = false;
                btn.textContent = prev;
                btn.classList.remove('luxio-lp-card__btn--done');
              }, 2400);
            }
          })
          .catch(function (err) {
            notifyError(err.message);
          });
      });
    });
  }

  function strAddToCart() {
    return (window.luxioTutorialCartStrings && window.luxioTutorialCartStrings.addToCart) || 'Dodaj do koszyka';
  }
  function strSoldOut() {
    return (window.luxioTutorialCartStrings && window.luxioTutorialCartStrings.soldOut) || 'Wyprzedane';
  }

  function luxioStepMoneyFormat() {
    return (
      (typeof theme !== 'undefined' && theme && theme.moneyFormat) ||
      (typeof Shopify !== 'undefined' && Shopify.money_format) ||
      '{{amount}}'
    );
  }
  function setStepCardPrice(priceEl, price, compare) {
    var cents = parseInt(price, 10);
    var cmp = parseInt(compare, 10) || 0;
    if (!priceEl || !isFinite(cents)) return;
    var mf = luxioStepMoneyFormat();
    function fmtMoney(c) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        try {
          return Shopify.formatMoney(c, mf);
        } catch (e) {
          return Shopify.formatMoney(c);
        }
      }
      return (c / 100).toFixed(2);
    }
    if (cmp > cents) {
      priceEl.innerHTML =
        '<span class="luxio-step-card__price-reduced">' +
        fmtMoney(cents) +
        '</span> <span class="luxio-step-card__price-compare">' +
        fmtMoney(cmp) +
        '</span>';
    } else {
      priceEl.textContent = fmtMoney(cents);
    }
  }

  function initCollectionRowRails(root) {
    var bases = [];
    if (root && root.querySelectorAll) {
      qsa(root, '.luxio-lp-root').forEach(function (el) {
        bases.push(el);
      });
      if (root.classList && root.classList.contains('luxio-lp-root')) {
        bases.push(root);
      }
    }
    if (!bases.length) {
      bases = qsa(document, '.luxio-lp-root');
    }
    bases.forEach(function (base) {
      qsa(base, '[data-variant-select]').forEach(function (sel) {
        if (sel.dataset.luxioCrVariantBound) return;
        if (!sel.closest('.luxio-lp-root')) return;
        var stepCard = sel.closest('.luxio-step-card');
        var crCard = sel.closest('.collection-row__product');
        if (!stepCard && !crCard) return;
        sel.dataset.luxioCrVariantBound = '1';
        var card = stepCard || crCard;
        var priceEl = card.querySelector('[data-variant-price]');
        var btn = card.querySelector('[data-add-button]');
        sel.addEventListener('change', function () {
          var opt = sel.options[sel.selectedIndex];
          var price = opt.getAttribute('data-price');
          var compare = opt.getAttribute('data-compare') || 0;
          var available = opt.getAttribute('data-available') === 'true';
          if (priceEl && price) {
            if (stepCard) {
              setStepCardPrice(priceEl, price, compare);
            } else {
              var fmt;
              if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
                fmt = Shopify.formatMoney(price);
              } else {
                fmt = (parseInt(price, 10) / 100).toFixed(2);
              }
              if (compare && parseInt(compare, 10) > parseInt(price, 10)) {
                if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
                  priceEl.innerHTML =
                    '<span class="product-price__reduced">' +
                    fmt +
                    '</span> <span class="product-price__compare">' +
                    Shopify.formatMoney(compare) +
                    '</span>';
                } else {
                  priceEl.textContent = fmt;
                }
              } else {
                priceEl.textContent = fmt;
              }
            }
          }
          if (btn) {
            btn.disabled = !available;
            btn.textContent = available ? strAddToCart() : strSoldOut();
          }
        });
      });

      qsa(base, '.collection-row__qty').forEach(function (wrapper) {
        if (wrapper.dataset.luxioCrQtyBound) return;
        wrapper.dataset.luxioCrQtyBound = '1';
        var input = qs(wrapper, '.collection-row__qty-input');
        if (!input) return;
        var minus = qs(wrapper, '[data-qty-minus]');
        var plus = qs(wrapper, '[data-qty-plus]');
        function clamp(val) {
          var n = parseInt(val, 10);
          if (isNaN(n) || n < 1) n = 1;
          if (n > 99) n = 99;
          return n;
        }
        if (minus) {
          minus.addEventListener('click', function () {
            input.value = String(clamp((parseInt(input.value, 10) || 1) - 1));
          });
        }
        if (plus) {
          plus.addEventListener('click', function () {
            input.value = String(clamp((parseInt(input.value, 10) || 1) + 1));
          });
        }
        input.addEventListener('change', function () {
          input.value = String(clamp(input.value));
        });
      });

      function bindAjaxAddForm(form, doneClass) {
        if (form.dataset.luxioCrAjaxBound) return;
        form.dataset.luxioCrAjaxBound = '1';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('[data-add-button]');
          var prev = btn ? btn.textContent : '';
          fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          })
            .then(function (r) {
              return r.json().then(function (j) {
                if (!r.ok) throw new Error((j && j.description) || r.statusText);
                return j;
              });
            })
            .then(function () {
              notifySuccess();
              updateCartIndicator();
              document.dispatchEvent(new CustomEvent('luxio:cart-changed', { detail: { added: true } }));
              var card = form.closest('.luxio-step-card');
              if (card) {
                card.classList.remove('luxio-step-card--burst');
                void card.offsetWidth;
                card.classList.add('luxio-step-card--burst');
                setTimeout(function () {
                  card.classList.remove('luxio-step-card--burst');
                }, 900);
              }
              if (btn) {
                btn.disabled = true;
                btn.textContent = 'Dodano';
                btn.classList.add(doneClass || 'luxio-cr-add--done');
                setTimeout(function () {
                  btn.disabled = false;
                  btn.textContent = prev;
                  btn.classList.remove(doneClass || 'luxio-cr-add--done');
                }, 2600);
              }
            })
            .catch(function (err) {
              notifyError(err.message);
            });
        });
      }

      qsa(base, '.collection-row__add-form').forEach(function (form) {
        bindAjaxAddForm(form, 'luxio-cr-add--done');
      });
      qsa(base, '.luxio-step-card__add-form').forEach(function (form) {
        bindAjaxAddForm(form, 'luxio-step-card__btn--done');
      });
    });
  }

  function initStepNav(root) {
    root = root || document;
    var nav = qs(root, '[data-luxio-step-nav]');
    if (!nav) nav = qs(document, '[data-luxio-step-nav]');
    if (!nav) return;
    if (nav.dataset.luxioStepNavInit === '1') return;
    nav.dataset.luxioStepNavInit = '1';

    var links = qsa(nav, 'a[data-luxio-step-anchor]');
    if (!links.length) return;

    function setActive(id) {
      links.forEach(function (link) {
        var lid = link.getAttribute('data-luxio-step-anchor');
        if (lid === id) link.classList.add('luxio-lp-step-nav__link--active');
        else link.classList.remove('luxio-lp-step-nav__link--active');
      });
    }

    nav.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[data-luxio-step-anchor]') : null;
      if (!a || !nav.contains(a)) return;
      var id = a.getAttribute('data-luxio-step-anchor');
      if (id) setActive(id);
    });

    /* Na mobile reels scroll jest w .luxio-lp-reels-scroller — observer na viewport generuje dziesiątki wywołań/sec i laguje. Zostawiamy tylko klik + dots reels. */
    var lpRoot = qs(document, '.luxio-lp-root');
    var skipIo =
      lpRoot &&
      lpRoot.getAttribute('data-luxio-mobile-reels') === '1' &&
      typeof window.matchMedia !== 'undefined' &&
      window.matchMedia('(max-width: 639px)').matches;

    if (skipIo || !('IntersectionObserver' in window)) return;

    var sections = [];
    links.forEach(function (link) {
      var id = link.getAttribute('data-luxio-step-anchor');
      if (!id) return;
      var el = document.getElementById(id);
      if (el) sections.push({ id: id, el: el });
    });
    if (!sections.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        var visible = entries.filter(function (en) {
          return en.isIntersecting && en.intersectionRatio >= 0.15;
        });
        if (!visible.length) return;
        visible.sort(function (a, b) {
          return b.intersectionRatio - a.intersectionRatio;
        });
        var id = visible[0].target.id;
        if (id) setActive(id);
      },
      { root: null, rootMargin: '-18% 0px -52% 0px', threshold: [0.2, 0.45] }
    );

    sections.forEach(function (s) {
      io.observe(s.el);
    });
  }

  function initReveal(root) {
    if (!('IntersectionObserver' in window)) {
      qsa(root, '.luxio-lp-card').forEach(function (el) {
        el.classList.add('luxio-lp-card--visible');
      });
      qsa(root, '.luxio-lp-root .collection-row__product').forEach(function (el) {
        el.classList.add('luxio-lp-reveal--in');
      });
      qsa(root, '.luxio-lp-root .luxio-step-card').forEach(function (el) {
        el.classList.add('luxio-step-card--visible');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            if (en.target.classList.contains('luxio-lp-card')) {
              en.target.classList.add('luxio-lp-card--visible');
            }
            if (en.target.classList.contains('collection-row__product')) {
              en.target.classList.add('luxio-lp-reveal--in');
            }
            if (en.target.classList.contains('luxio-step-card')) {
              en.target.classList.add('luxio-step-card--visible');
            }
            io.unobserve(en.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    qsa(root, '.luxio-lp-card').forEach(function (el) {
      io.observe(el);
    });
    qsa(root, '.luxio-lp-root .collection-row__product').forEach(function (el) {
      io.observe(el);
    });
    qsa(root, '.luxio-lp-root .luxio-step-card').forEach(function (el) {
      io.observe(el);
    });
  }

  function initCompare(root) {
    var box = qs(root, '.luxio-lp-compare__box');
    if (!box) return;
    var range = qs(box, '.luxio-lp-compare__range');
    if (!range) return;
    function setClip(v) {
      box.style.setProperty('--luxio-clip', v + '%');
    }
    setClip(50);
    range.addEventListener('input', function () {
      setClip(range.value);
    });
  }

  function initThemeToggle(root) {
    var wrap = qs(root, '.luxio-lp-root');
    if (!wrap) return;
    var btn = qs(root, '.luxio-lp-theme-toggle');
    if (!btn) return;
    var key = 'luxio_lp_dark';
    try {
      if (localStorage.getItem(key) === '1') wrap.classList.add('luxio-lp-root--dark');
    } catch (e) {}
    function syncAria() {
      var on = wrap.classList.contains('luxio-lp-root--dark');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    syncAria();
    btn.addEventListener('click', function () {
      wrap.classList.toggle('luxio-lp-root--dark');
      try {
        localStorage.setItem(key, wrap.classList.contains('luxio-lp-root--dark') ? '1' : '0');
      } catch (e) {}
      syncAria();
    });
  }

  function initRailNav(root) {
    qsa(root, '.luxio-lp-rail-wrap').forEach(function (wrap) {
      var rail = qs(wrap, '.luxio-lp-rail');
      var prev = qs(wrap, '[data-luxio-rail-prev]');
      var next = qs(wrap, '[data-luxio-rail-next]');
      if (!rail || !prev || !next) return;
      function scrollStep() {
        return Math.min(280, rail.clientWidth * 0.85);
      }
      function syncOverflow() {
        var overflow = rail.scrollWidth - rail.clientWidth > 6;
        prev.style.display = overflow ? '' : 'none';
        next.style.display = overflow ? '' : 'none';
      }
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        rail.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      rail.addEventListener('scroll', syncOverflow);
      window.addEventListener('resize', syncOverflow);
      syncOverflow();
    });
  }

  function nudgeKitProgress(bar) {
    var prog = qs(bar, '.luxio-lp-kitbar__progress');
    if (!prog) return;
    prog.classList.remove('luxio-lp-kitbar__progress--nudge');
    void prog.offsetWidth;
    prog.classList.add('luxio-lp-kitbar__progress--nudge');
    setTimeout(function () {
      prog.classList.remove('luxio-lp-kitbar__progress--nudge');
    }, 700);
  }

  function flashKitBar(bar) {
    if (!bar) return;
    bar.classList.remove('luxio-lp-kitbar--flash');
    void bar.offsetWidth;
    bar.classList.add('luxio-lp-kitbar--flash');
    nudgeKitProgress(bar);
    setTimeout(function () {
      bar.classList.remove('luxio-lp-kitbar--flash');
    }, 900);
  }

  function initKitBar() {
    var bar = qs(document, '.luxio-lp-kitbar');
    if (!bar) return;
    var slots = parseProtocolSlots();
    if (!slots.length) return;
    var msgs = parseKitMsgs();
    var msgEl = qs(bar, '[data-luxio-kit-msg]');
    var fill = qs(bar, '.luxio-lp-kitbar__fill');
    var fractionEl = qs(bar, '[data-luxio-kit-fraction]');
    var pillEl = qs(bar, '[data-luxio-kit-pill]');
    var progressEl = qs(bar, '.luxio-lp-kitbar__progress');
    var total = slots.length;
    var lastCount = -1;

    function setFill(pct) {
      if (fill) fill.style.setProperty('--luxio-fill', pct + '%');
    }

    function setQuestPill(count, pct, left) {
      if (!progressEl) return;
      progressEl.classList.remove(
        'luxio-lp-kitbar__progress--half',
        'luxio-lp-kitbar__progress--final',
        'luxio-lp-kitbar__progress--complete'
      );
      bar.classList.remove('luxio-lp-kitbar--complete');
      if (pillEl) {
        if (count <= 0) pillEl.textContent = 'Start zestawu';
        else if (count >= total) pillEl.textContent = 'Pełny zestaw ✓';
        else pillEl.textContent = 'Zbierasz zestaw';
      }
      if (count >= total) {
        progressEl.classList.add('luxio-lp-kitbar__progress--complete');
        bar.classList.add('luxio-lp-kitbar--complete');
        return;
      }
      if (pct >= 50 && left > 0) progressEl.classList.add('luxio-lp-kitbar__progress--half');
      if (left === 1) progressEl.classList.add('luxio-lp-kitbar__progress--final');
    }

    function missingHandles(cart) {
      var missing = [];
      slots.forEach(function (slot) {
        var vids = slot.variants || [];
        var hit = vids.some(function (vid) {
          return cartHasVariantId(cart, vid);
        });
        if (!hit) {
          var hs = slot.handles || [];
          missing.push(hs.length ? String(hs[0]).toLowerCase() : '');
        }
      });
      return missing;
    }

    function countFromCart(cart) {
      var n = 0;
      slots.forEach(function (slot) {
        var vids = slot.variants || [];
        var hit = vids.some(function (vid) {
          return cartHasVariantId(cart, vid);
        });
        if (hit) n++;
      });
      return Math.min(n, total);
    }

    function render(count, cart) {
      var pct = Math.round((count / total) * 100);
      setFill(pct);
      var left = total - count;
      if (fractionEl) fractionEl.textContent = count + ' / ' + total;
      setQuestPill(count, pct, left);
      if (!msgEl) return;
      if (left <= 0) {
        msgEl.innerHTML = msgs.done || '<strong>Pełny zestaw kroków</strong> — wszystkie produkty protokołu w koszyku.';
        return;
      }
      if (left === 1) {
        var miss = missingHandles(cart || { items: [] });
        var h0 = miss[0] || '';
        if (h0.indexOf('top') !== -1 && msgs.top_hint) msgEl.innerHTML = msgs.top_hint;
        else msgEl.innerHTML = msgs.one || 'Brakuje <strong>1 produktu</strong> z protokołu Luxio.';
        return;
      }
      var tpl = msgs.many || 'Brakuje <strong>{{n}} produktów</strong> z protokołu Luxio.';
      msgEl.innerHTML = tpl.split('{{n}}').join(String(left));
    }

    function sync(ev) {
      fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var c = countFromCart(cart);
          if (ev && ev.detail && ev.detail.added && lastCount >= 0 && c > lastCount) flashKitBar(bar);
          lastCount = c;
          render(c, cart);
        })
        .catch(function () {});
    }

    sync();
    document.addEventListener('luxio:cart-changed', sync);
  }

  function closePop(pop) {
    if (!pop || !pop.parentNode) return;
    document.removeEventListener('keydown', pop._luxioKd);
    document.removeEventListener('click', pop._luxioCd);
    pop.parentNode.removeChild(pop);
  }

  function initMobileReels(root) {
    var lp = null;
    if (root && root.querySelector) lp = qs(root, '.luxio-lp-root');
    if (!lp && root && root.closest) lp = root.closest('.luxio-lp-root');
    if (!lp) lp = qs(document, '.luxio-lp-root');
    if (!lp || lp.getAttribute('data-luxio-mobile-reels') !== '1') return;

    var scrollEl = qs(lp, '.luxio-lp-reels-scroller');
    var mq = window.matchMedia('(max-width: 639px)');
    var io = null;
    var lastReelsSlideIdx = -999;
    var reelsIoPending = null;
    var reelsIoRaf = 0;

    function syncDots(activeIdx) {
      qsa(lp, '[data-luxio-reels-dot]').forEach(function (dot) {
        var di = Number(dot.getAttribute('data-luxio-reels-dot'));
        if (di === activeIdx) dot.classList.add('luxio-lp-reels-dot--active');
        else dot.classList.remove('luxio-lp-reels-dot--active');
      });
    }

    function pauseOffscreenVideos(activeSlide) {
      qsa(lp, '.luxio-lp-reels-scroller video').forEach(function (vid) {
        var slide = vid.closest('.luxio-lp-reels-snap');
        var on = slide === activeSlide;
        if (on) {
          if (vid.paused) vid.play().catch(function () {});
        } else {
          if (!vid.paused) {
            try {
              vid.pause();
            } catch (e) {}
          }
        }
      });
    }

    /**
     * Strefa „Instagram swipe”: tylko wideo / overlay — wtedy scroll-snap może działać.
     * Tekst, lista zakupów, formularze — bez snap (klasa --free-scroll), żeby dało się czytać i klikać.
     */
    function isReelsSnapSwipeZone(el) {
      if (!el || !el.closest) return false;
      if (
        el.closest(
          '.luxio-lp-step__media, .luxio-lp-story-row__media, .luxio-lp-lamp .luxio-lp-step__media, .luxio-lp-hero__video, .luxio-lp-hero__video--still, .luxio-lp-hero__video--card, .luxio-lp-hero__visual-card, .luxio-lp-hero__overlay'
        )
      )
        return true;
      return false;
    }

    function bindReelsScrollSnapGuardOnce() {
      if (!scrollEl || scrollEl.dataset.luxioReelsSnapGuard) return;
      scrollEl.dataset.luxioReelsSnapGuard = '1';
      var clearTimer = null;
      function clearFreeScrollSoon() {
        if (clearTimer) clearTimeout(clearTimer);
        clearTimer = setTimeout(function () {
          clearTimer = null;
          scrollEl.classList.remove('luxio-lp-reels-scroller--free-scroll');
        }, 420);
      }
      function onPointerDown(e) {
        if (!mq.matches) return;
        var t = e.target;
        if (t && t.closest && t.closest('select, button, input, textarea, label')) {
          scrollEl.classList.add('luxio-lp-reels-scroller--free-scroll');
          return;
        }
        if (isReelsSnapSwipeZone(t)) {
          scrollEl.classList.remove('luxio-lp-reels-scroller--free-scroll');
        } else {
          scrollEl.classList.add('luxio-lp-reels-scroller--free-scroll');
        }
      }
      function onPointerUp() {
        if (!mq.matches) return;
        clearFreeScrollSoon();
      }
      scrollEl.addEventListener('touchstart', onPointerDown, { passive: true });
      scrollEl.addEventListener('touchend', onPointerUp, { passive: true });
      scrollEl.addEventListener('touchcancel', onPointerUp, { passive: true });
      scrollEl.addEventListener('pointerdown', onPointerDown, { passive: true });
      scrollEl.addEventListener('pointerup', onPointerUp, { passive: true });
      scrollEl.addEventListener('pointercancel', onPointerUp, { passive: true });
    }

    function bindDotClicksOnce() {
      if (lp.dataset.luxioReelsDotsClick) return;
      lp.dataset.luxioReelsDotsClick = '1';
      lp.addEventListener('click', function (e) {
        if (!mq.matches) return;
        var dot = e.target.closest ? e.target.closest('[data-luxio-reels-dot]') : null;
        if (!dot || !lp.contains(dot)) return;
        var idx = dot.getAttribute('data-luxio-reels-dot');
        var target = lp.querySelector('[data-luxio-reels-slide="' + idx + '"]');
        if (target && scrollEl) {
          var smooth = true;
          try {
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) smooth = false;
          } catch (e2) {}
          target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
        }
      });
    }

    function teardownObserver() {
      if (io) {
        io.disconnect();
        io = null;
      }
    }

    function setupReels() {
      teardownObserver();
      bindDotClicksOnce();
      bindReelsScrollSnapGuardOnce();

      if (!mq.matches || !scrollEl) {
        syncDots(-999);
        qsa(lp, '[data-luxio-reels-dot]').forEach(function (d) {
          d.classList.remove('luxio-lp-reels-dot--active');
        });
        return;
      }

      var slides = qsa(lp, '.luxio-lp-reels-snap');
      if (!slides.length) return;

      if (!('IntersectionObserver' in window)) return;

      io = new IntersectionObserver(
        function (entries) {
          reelsIoPending = entries;
          if (reelsIoRaf) return;
          reelsIoRaf = requestAnimationFrame(function () {
            reelsIoRaf = 0;
            var batch = reelsIoPending;
            reelsIoPending = null;
            if (!batch || !batch.length) return;
            var chosen = batch
              .filter(function (e) {
                return e.isIntersecting && e.intersectionRatio >= 0.28;
              })
              .sort(function (a, b) {
                return b.intersectionRatio - a.intersectionRatio;
              })[0];
            if (!chosen) return;
            var idx = Number(chosen.target.getAttribute('data-luxio-reels-slide'));
            if (isNaN(idx)) return;
            if (idx !== lastReelsSlideIdx) {
              lastReelsSlideIdx = idx;
              syncDots(idx);
            }
            pauseOffscreenVideos(chosen.target);
          });
        },
        {
          root: scrollEl,
          threshold: [0, 0.35, 0.55],
          rootMargin: '-12% 0px -28% 0px',
        }
      );

      slides.forEach(function (s) {
        io.observe(s);
      });

      /* pierwszy aktywny po załadowaniu */
      requestAnimationFrame(function () {
        var first = slides[0];
        if (first) {
          var i0 = Number(first.getAttribute('data-luxio-reels-slide'));
          if (!isNaN(i0)) syncDots(i0);
          pauseOffscreenVideos(first);
        }
      });
    }

    setupReels();
    if (mq.addEventListener) mq.addEventListener('change', setupReels);
    else if (mq.addListener) mq.addListener(setupReels);
  }

  function initHotspots(root) {
    qsa(root, '[data-luxio-hotspot]').forEach(function (btn) {
      if (btn.dataset.luxioHotspotBound) return;
      btn.dataset.luxioHotspotBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        qsa(document, '.luxio-lp-hp-pop').forEach(function (p) {
          closePop(p);
        });
        var vid = btn.getAttribute('data-variant-id');
        var url = btn.getAttribute('data-product-url') || '#';
        var label = btn.getAttribute('data-label') || 'Produkt';
        var pop = document.createElement('div');
        pop.className = 'luxio-lp-hp-pop';
        pop.setAttribute('role', 'dialog');
        pop.innerHTML =
          '<p class="luxio-lp-hp-pop__title"></p><div class="luxio-lp-hp-pop__row">' +
          '<button type="button" class="luxio-lp-hp-pop__add" data-add>Dodaj do koszyka</button>' +
          '<a class="luxio-lp-hp-pop__link" data-link>Produkt</a></div>';
        qs(pop, '.luxio-lp-hp-pop__title').textContent = label;
        var addB = qs(pop, '[data-add]');
        var link = qs(pop, '[data-link]');
        link.href = url;
        link.textContent = 'Zobacz';
        document.body.appendChild(pop);
        var r = btn.getBoundingClientRect();
        var top = Math.min(window.innerHeight - pop.offsetHeight - 12, r.bottom + 8);
        var left = Math.min(window.innerWidth - pop.offsetWidth - 12, Math.max(12, r.left - pop.offsetWidth / 2 + r.width / 2));
        pop.style.top = top + 'px';
        pop.style.left = left + 'px';
        addB.addEventListener('click', function () {
          if (!vid) return;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }),
          })
            .then(function (r) {
              return r.json().then(function (j) {
                if (!r.ok) throw new Error((j && j.description) || r.statusText);
                return j;
              });
            })
            .then(function () {
              notifySuccess();
              updateCartIndicator();
              document.dispatchEvent(new CustomEvent('luxio:cart-changed', { detail: { added: true } }));
              closePop(pop);
            })
            .catch(function (err) {
              notifyError(err.message);
            });
        });
        pop._luxioKd = function (ev) {
          if (ev.key === 'Escape') closePop(pop);
        };
        pop._luxioCd = function (ev) {
          if (!pop.contains(ev.target)) closePop(pop);
        };
        setTimeout(function () {
          document.addEventListener('keydown', pop._luxioKd);
          document.addEventListener('click', pop._luxioCd);
        }, 0);
      });
    });
  }

  function luxioVideosUseReelsMobile(root) {
    var lp = root && root.querySelector ? qs(root, '.luxio-lp-root') : qs(document, '.luxio-lp-root');
    if (!lp) return false;
    return lp.getAttribute('data-luxio-mobile-reels') === '1' && window.matchMedia && window.matchMedia('(max-width: 639px)').matches;
  }

  /** Desktop / tablet: odtwarzaj tylko klipy widoczne w viewport — mniejszy transfer niż preload na całej stronie. Na mobile reels steruje pauseOffscreenVideos. */
  function initManagedVideos(root) {
    var lp = root && root.querySelector ? qs(root, '.luxio-lp-root') : qs(document, '.luxio-lp-root');
    if (!lp) return;
    if (luxioVideosUseReelsMobile(lp)) return;
    if (!('IntersectionObserver' in window)) {
      qsa(lp, 'video[data-luxio-managed]').forEach(function (v) {
        try {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } catch (e) {}
      });
      return;
    }

    function shouldPlay(el, entry) {
      if (!(el instanceof HTMLVideoElement)) return false;
      return entry.isIntersecting && entry.intersectionRatio >= 0.22;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (!(v instanceof HTMLVideoElement)) return;
          var on = shouldPlay(v, entry);
          if (on) {
            if (v.readyState === 0) {
              try {
                v.preload = 'metadata';
                v.load();
              } catch (e) {}
            }
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});
          } else {
            if (!v.paused) {
              try {
                v.pause();
              } catch (e2) {}
            }
          }
        });
      },
      {
        root: null,
        rootMargin: '-4% 0px -8% 0px',
        threshold: [0, 0.12, 0.28, 0.45],
      }
    );

    qsa(lp, 'video[data-luxio-managed]').forEach(function (v) {
      io.observe(v);
    });
  }

  function initHeroVisualVideo(root) {
    qsa(root, '.luxio-lp-hero__visual-card video.luxio-lp-hero__video--card').forEach(function (vid) {
      if (vid.dataset.luxioHeroVideoBound) return;
      vid.dataset.luxioHeroVideoBound = '1';
      var card = vid.closest('.luxio-lp-hero__visual-card');
      if (!card) return;
      function markPlaying() {
        card.classList.add('luxio-lp-hero__visual-card--playing');
      }
      vid.addEventListener('playing', markPlaying);
      vid.addEventListener('timeupdate', markPlaying);
      try {
        var pr = vid.play();
        if (pr && typeof pr.then === 'function') pr.catch(function () {});
      } catch (e) {}
      card.addEventListener(
        'click',
        function () {
          try {
            var p2 = vid.play();
            if (p2 && typeof p2.then === 'function') p2.catch(function () {});
          } catch (e2) {}
        },
        { once: true }
      );
    });
  }

  function init(root) {
    root = root || document;
    initCardVariantQty(root);
    initAjaxAdd(root);
    initCollectionRowRails(root);
    initReveal(root);
    initCompare(root);
    initThemeToggle(root);
    initRailNav(root);
    initHotspots(root);
    initStepNav(root);
    initHeroVisualVideo(root);
    initManagedVideos(root);
    initMobileReels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      initKitBar();
    });
  } else {
    init(document);
    initKitBar();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    init(ev.target);
  });
})();

